/**
 * Faceted Search Accordion
 */

const accordionGroups = document.querySelectorAll('.facet__accordion__wrapper');

// Accordion main functionalities
function faceted_search_accordion() {
    accordionGroups.forEach((accordion, index) => {
        const activeButton = accordion.querySelector(
            '.facet__accordion__button'
        );
        const activePanel = accordion.querySelector('.facet__accordion__panel');

        activeButton.addEventListener('click', function () {
            this.classList.toggle('-open');
            const activePanelIsOpened = this.getAttribute('aria-expanded');

            if (activePanelIsOpened === 'true') {
                this.setAttribute('aria-expanded', false);
                activePanel.setAttribute('aria-hidden', true);
                activePanel.style.display = 'none';
                activePanel.style.maxHeight = null;
                localStorage.removeItem('accordion' + index);
            } else {
                this.setAttribute('aria-expanded', true);
                activePanel.setAttribute('aria-hidden', false);
                activePanel.style.display = 'block';
                activePanel.style.maxHeight = activePanel.scrollHeight + 'px';
                localStorage.setItem('accordion' + index, 'open');
            }
        });
    });
}

faceted_search_accordion();
